import React from "react";
import style from "./userdocuments.module.css";
import dummy_docs from "../../../Assets/images/document_default.png";
import { useFetchAll } from "../../../custom/FetchApiHook";
import { DocApi } from "../../../App/api/document.apis";
const UserDocuments = ({ itemData }) => {
  const { value ,loading} = useFetchAll(() => DocApi.getDocument(itemData?._id));
 const documentData = value?.data || [];
  // console.log("document data", documentData);
  return (
    <>
      <div className={style.main}>
        {loading && (
        <div className={style.emptyBox}>
          <div className={style.loader}></div>
          <p>Loading documents...</p>
        </div>
      )}

       {/* Empty State */}
     {!loading && documentData.length === 0 && (
  <div className="flex flex-col items-center justify-center min-h-[400px] py-16 px-6 text-center">
    {/* Beautiful SVG Illustration or Image */}
    <div className="mb-8 relative">
      <img 
        src={dummy_docs} 
        alt="No documents" 
        className="w-48 h-48 md:w-64 md:h-64 opacity-90 drop-shadow-lg"
      />
      {/* Optional subtle background decoration */}
      <div className="absolute -top-6 -left-6 w-32 h-32 bg-blue-100 rounded-full blur-3xl opacity-30 -z-10"></div>
      <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-purple-100 rounded-full blur-3xl opacity-30 -z-10"></div>
    </div>

    {/* Main Message */}
    <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">
      No Documents Found
    </h2>
    
    <p className="text-gray-500 text-base md:text-lg max-w-md leading-relaxed">
      This user hasn’t uploaded any documents yet. Once they do, they’ll appear here.
    </p>

   

    {/* Decorative subtle line */}
    <div className="mt-12 w-32 h-1 bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
  </div>
)}

        {!loading &&
        documentData.length > 0 &&
        documentData.map((item) => (
          <div className={style.card}>
            <div className="w-[50%] h-full">
              <img
                src={item?.image || dummy_docs}
                alt={item?.name}
                className="w-full rounded-md"
                width={400}
              />
            </div>
            <div style={{ marginTop: "0.6rem" }}>
              <h1
                style={{
                  color: "var(--text-color3)",
                  textTransform: "capitalize",
                }}
              >
                {item?.name}
              </h1>

              <p style={{ marginTop: "0.4rem", fontWeight: "600" }}>
                Expiry Date
              </p>
              <p style={{ marginTop: "0.4rem" }}>{item?.expiry_date}</p>

              <p style={{ marginTop: "0.4rem", fontWeight: "600" }}>
                Unique Code
              </p>
              <p style={{ marginTop: "1rem" }}>{item?.unique_code}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default UserDocuments;
